<template>
    <el-tooltip class="item ml-1"
                effect="dark"
                :placement="placement">
        <div slot="content">
            Here you can see the inboxes associated with this team. To manage the inboxes, you can go to the Inboxes page.
        </div>
        <i class="material-icons text-sm cursor-pointer text-blue"
           :style="`z-index: ${zIndex} !important;`">info_outline</i>
    </el-tooltip>
</template>

<script>
export default {
    name: 'TeamRingGroupsTooltip',

    props: {
        placement: {
            type: String,
            default: 'top'
        },
        zIndex: {
            type: Number,
            default: 2005
        }
    }
}
</script>
